let clinicalSkillsGroup = {
    name: ''
};

export default clinicalSkillsGroup;